import React, { useState, useEffect } from 'react';
import * as Stomp from '@stomp/stompjs';
import NotificationSnacker from './NotificationSnacker';
import { REACT_APP_SOCKET_CONNECTION_URL } from 'src/utils/pnd/config';

const ChatNotification = () => {
  const [messageQueue, setMessageQueue] = useState([]);
  const [currentNotification, setCurrentNotification] = useState(null);
  let stompClient = null;
  let reconnectTimeout = null;

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      console.log('No access token found, skipping WebSocket connection');
      return;
    }

    const connect = () => {
      try {
        stompClient = Stomp.Stomp.over(() => new WebSocket(REACT_APP_SOCKET_CONNECTION_URL));

        stompClient.onConnect = () => {
          console.log('Connected to WebSocket');
          stompClient.subscribe('/topic/notification', (message) => {
            const data = JSON.parse(message.body);
            console.log(data);

            // Only notify if the notifyTo matches the current user's UI
            if (data?.notifyTo == localStorage.getItem("ui")) {
              const newMessage = {
                pushTitle: data?.pushTitle || 'Default Title', // Fallback title
                pushMessage: data?.pushMessage || '',
              };

              setMessageQueue((prevQueue) => [...prevQueue, newMessage]);
            }
          });
        };

        stompClient.onStompError = (frame) => {
          console.error('Broker reported error: ' + frame.headers['message']);
          console.error('Additional details: ' + frame.body);
        };
        stompClient.activate();
        stompClient.onWebSocketClose = (closeEvent) => {
          console.error('WebSocket connection closed:', closeEvent);
          // Only attempt reconnect if we still have a token
          if (localStorage.getItem('access_token')) {
            reconnectTimeout = setTimeout(connect, 5000); // Reconnect after 5 seconds
          }
        };
        stompClient.onWebSocketError = (error) => {
          console.error('WebSocket error:', error);
        };
      } catch (error) {
        console.error('Error establishing WebSocket connection:', error);
      }
    };

    connect();
    return () => {
      if (stompClient) {
        stompClient.deactivate();
      }
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
      }
    };
  }, []);

  // Effect to handle displaying notifications one by one
  useEffect(() => {
    if (messageQueue.length > 0 && !currentNotification) {
      setCurrentNotification(messageQueue[0]);
      setMessageQueue((prevQueue) => prevQueue.slice(1));
    }
  }, [messageQueue, currentNotification]);

  // Function to close the notification
  const handleCloseNotification = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setCurrentNotification(null);
  };

  return (
    <div>
      {/* <h2>Chat Messages</h2> */}
      <ul>
        {messageQueue.concat(currentNotification ? [currentNotification] : []).map((msg, index) => (
          <li key={index}>
            <strong>{msg.pushTitle}</strong>: {msg.pushMessage}
          </li>
        ))}
      </ul>
      <NotificationSnacker
        open={Boolean(currentNotification)}
        message={`${currentNotification?.pushTitle || ''}`}
        // : ${currentNotification?.pushMessage || ''}
        severity="info"
        onClose={handleCloseNotification}
      />
    </div>
  );
};

export default ChatNotification;
